module.exports = __webpack_public_path__ + "img/empty-temp-introduce-3.00e9073f.jpg";